<template>
  <div class="page_box">
    <div class="page_option_box" style="font-size:18px">
      <span v-if="status == 0">
        {{ type == "add" ? "新增隐患小组" : "修改隐患小组" }}
      </span>
      <span v-else>
        {{ type == "add" ? "新增报修小组" : "修改报修小组" }}
      </span>
    </div>
    <div class="page_table_box">
      <div style="overflow-y: scroll;height:calc(100% - 60px)">
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label">小组名称 </label>
            <div class="col-sm-10">
              <input
                type="text"
                v-model.trim="form.securityTeamName"
                class="form-control"
                placeholder="请输入部门名称"
              />
            </div>
          </div>
          <div class="form-group options_box">
            <label class="col-sm-2 control-label">组长</label>
            <div class="col-sm-10">
              <el-cascader
                ref="cascaderOneRef"
                @change="selectGroupMember"
                @remove-tag="removeTagMember"
                placeholder="请选择您要添加的组长"
                :options="teamMemberList"
                v-model="teamMemberValue"
                :props="{ multiple: true, value: 'id', label: 'label' }"
                filterable
                collapse-tags
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </div>
          </div>
          <div>
            <div
              class="form-group"
              v-for="(value, key) in form.teamMemberList"
              :key="key"
            >
              <label class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <div class="form-group">
                  <div class="col-sm-4">
                    <input
                      type="text"
                      class="form-control"
                      :disabled="true"
                      v-model.trim="value.userName"
                    />
                  </div>
                  <div class="col-sm-8">
                    <label class="col-sm-2 control-label">
                      职责：
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="如：水电"
                        v-model.trim="value.teamMemberResponsibilities"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group options_box">
            <label class="col-sm-2 control-label">{{
              userInfo.eduBuresuType == -1 ? "处理人员" : "后勤人员"
            }}</label>
            <div class="col-sm-10">
              <el-cascader
                ref="cascaderTwoRef"
                @remove-tag="removeTagLeader"
                @change="selectGroupLeader"
                :placeholder="
                  userInfo.eduBuresuType == -1
                    ? '点击选择处理人员'
                    : '点击选择后勤人员'
                "
                :options="teamLeaderList"
                v-model="teamLeaderValue"
                :props="{
                  multiple: true,
                  value: 'id',
                  label: 'label'
                }"
                filterable
                collapse-tags
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </div>
          </div>
          <div>
            <div
              class="form-group"
              v-for="(value, key) in form.teamLeaderList"
              :key="key"
            >
              <label class="col-sm-2 control-label"></label>
              <div class="col-sm-10">
                <div class="form-group">
                  <div class="col-sm-4">
                    <input
                      type="text"
                      class="form-control"
                      :disabled="true"
                      v-model.trim="value.userName"
                    />
                  </div>
                  <div class="col-sm-8">
                    <label class="col-sm-2 control-label">
                      职责：
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="如：水电"
                        v-model.trim="value.teamLeaderResponsibilities"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group options_box">
            <label class="col-sm-2 control-label">组员</label>
            <div class="col-sm-10">
              <el-tree
                style="margin-top:5px"
                v-loading="treeLoading"
                ref="teamMemberTree"
                :data="teamReporters"
                show-checkbox
                node-key="id"
                :props="defaultProps"
              >
              </el-tree>
            </div>
          </div>
        </form>
      </div>
      <div class="save-box">
        <el-button type="primary" size="mini" @click="addSecurityTeam"
          >确定提交</el-button
        >
        <el-button size="mini" @click="refeashData()">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddOrEditGroup",
  props: {
    type: {
      type: String,
      default: {
        return: "add"
      }
    },
    id: {
      type: String,
      default: {
        return: ""
      }
    },
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    },
    status: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      teamMemberValue: [], //当前选择的组长
      teamLeaderValue: [], //当前选择的后勤人员
      teamMemberList: [], //组长数组
      teamLeaderList: [], //后勤人员数组
      teamReporters: [], //组员数组
      form: {
        schoolId: this.$store.state.schoolId,
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [], //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
        teamReporters: [], //组员  userId组员id
        whetherHiddenGroup: this.status
      },
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      oldTeamMemberList: [],
      oldTeamLeaderList: []
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  mounted() {
    if (this.id) {
      this.form = Object.assign({}, this.defaultData);
      this.oldTeamMemberList = this.form.teamMemberList || [];
      this.oldTeamLeaderList = this.form.teamLeaderList || [];
      //   编辑
      for (let index = 0; index < 3; index++) {
        this.getTeamList(index + 1, this.id);
      }
    } else {
      //   新增
      for (let index = 0; index < 3; index++) {
        this.getTeamList(index + 1, "");
      }
    }
  },
  methods: {
    //获取组长-后勤人员-组员数组
    async getTeamList(index, id) {
      var params = {
        status: index,
        schoolId: parseInt(this.$store.state.schoolId),
        securityTeamId: id
      };
      this.treeLoading = true;
      let res = await this.$Http.getDepartmentHead(params, true);
      if (res.code == 200) {
        let data = res.data || [];
        let newTeamReporters = [];
        let list = data.map((item) => {
          let obj = {
            level: 1,
            id: item.departmentId || "",
            label: item.departmentName || "",
            children: []
          };
          newTeamReporters.push(item.departmentId);
          if (item.dlist) {
            obj.children = item.dlist.map((iitem) => {
              let objc = {
                level: 2,
                id: iitem.userId || "",
                label: iitem.userName || ""
              };
              newTeamReporters.push(iitem.userId);
              return objc;
            });
          }
          return obj;
        });
        if (index == 1) {
          this.teamMemberValue = [];
          this.form.teamMemberList.forEach((item) => {
            list.forEach((iitem) => {
              if (iitem.children) {
                iitem.children.forEach((iiitem) => {
                  if (item.userId == iiitem.id) {
                    this.teamMemberValue.push([iitem.id, iiitem.id]);
                    // console.log(iitem.id, iiitem.id)
                  }
                });
              }
            });
          });
          this.teamMemberList = [];
          this.teamMemberList = list;
        } else if (index == 2) {
          this.teamLeaderValue = [];
          this.form.teamLeaderList.forEach((item) => {
            list.forEach((iitem) => {
              if (iitem.children) {
                iitem.children.forEach((iiitem) => {
                  if (item.userId == iiitem.id) {
                    this.teamLeaderValue.push([iitem.id, iiitem.id]);
                  }
                });
              }
            });
          });
          this.teamLeaderList = [];
          this.teamLeaderList = list;
        } else {
          this.teamReporters = [];
          this.$refs.teamMemberTree.setCheckedKeys(newTeamReporters);
          this.teamReporters = list.map((item) => {
            item.disabled = true;
            if (item.children) {
              item.children = item.children.map((iitem) => {
                iitem.disabled = true;
                return iitem;
              });
            }
            return item;
          });
          this.treeLoading = false;
        }
      } else {
        if (index == 1) {
          this.teamMemberList = [];
        } else if (index == 2) {
          this.teamMemberList = [];
        } else {
          this.teamMemberList = [];
          this.treeLoading = false;
        }
      }
    },
    // 选择组长
    selectGroupMember(val) {
      // this.form.teamMemberList = val.map((item) => {
      //   let obj = {
      //     userId: item[1] || "",
      //   };
      //   return obj;
      // });
      this.$nextTick(() => {
        let dataList = this.$refs.cascaderOneRef.getCheckedNodes(true);
        console.log(this.$refs.cascaderOneRef.getCheckedNodes(), "ref");
        console.log(this.form.teamMemberList, "list");
        let newList = dataList.filter((item) => {
          return item.level == 2;
        });
        let newDataList = newList.map((item) => {
          let obj = {
            userId: item.value || "",
            userName: item.label || "",
            teamMemberResponsibilities: ""
          };
          return obj;
        });
        let self = this;
        newDataList.forEach((element, index) => {
          self.oldTeamMemberList.forEach((eelement, iindex) => {
            if (element.userId == eelement.userId) {
              element.teamMemberResponsibilities =
                eelement.teamMemberResponsibilities;
            }
          });
        });
        this.form.teamMemberList = newDataList || [];
        this.oldTeamMemberList = newDataList || [];
      });
    },
    removeTagMember(val) {
      this.form.teamMemberList = this.form.teamMemberList.filter((item) => {
        return item.userId != val[1];
      });
    },
    // 后勤人员选择
    selectGroupLeader(val) {
      console.log(val);
      this.$nextTick(() => {
        let dataList = this.$refs.cascaderTwoRef.getCheckedNodes(true);
        console.log(this.$refs.cascaderTwoRef.getCheckedNodes(), "ref");
        console.log(this.form.teamLeaderList, "list");
        let newList = dataList.filter((item) => {
          return item.level == 2;
        });
        let newDataList = newList.map((item) => {
          let obj = {
            userId: item.value || "",
            userName: item.label || "",
            teamLeaderResponsibilities: ""
          };
          return obj;
        });
        let self = this;
        newDataList.forEach((element, index) => {
          self.oldTeamLeaderList.forEach((eelement, iindex) => {
            if (element.userId == eelement.userId) {
              element.teamLeaderResponsibilities =
                eelement.teamLeaderResponsibilities;
            }
          });
        });
        this.form.teamLeaderList = newDataList || [];
        this.oldTeamLeaderList = newDataList || [];
      });
    },
    removeTagLeader(val) {
      this.form.teamLeaderList = this.form.teamLeaderList.filter((item) => {
        return item.userId != val[1];
      });
    },
    // 提交(新增或编辑)
    addSecurityTeam() {
      // 组员
      let treeNode = this.$refs.teamMemberTree.getCheckedNodes();
      let newList = treeNode.filter((item) => {
        return item.level == 2;
      });
      this.form.teamReporters = newList.map((item) => {
        let obj = {
          userId: item.id || ""
        };
        return obj;
      });
      this.addOrEditSecurityTeam();
    },
    async addOrEditSecurityTeam() {
      var addGroupData = Object.assign({}, this.form);
      if (addGroupData.securityTeamName == "") {
        this.$message({
          type: "warning",
          message: "请输入安全组名称"
        });
        return false;
      }
      if (addGroupData.teamMemberList.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选择组长"
        });
        return false;
      }
      let memberIndex = -1;
      memberIndex = addGroupData.teamMemberList.findIndex((item) => {
        return item.teamMemberResponsibilities == "";
      });
      if (memberIndex > -1) {
        this.$message({
          type: "warning",
          message:
            "请先给" +
            addGroupData.teamMemberList[memberIndex].userName +
            "组长增加职责!"
        });
        return false;
      }
      if (addGroupData.teamLeaderList.length < 1) {
        this.$message({
          type: "warning",
          message:
            this.userInfo.eduBuresuType == -1
              ? "请先选处理人员"
              : "请先选择后勤人员"
        });
        return false;
      }
      let index = -1;
      index = addGroupData.teamLeaderList.findIndex((item) => {
        return item.teamLeaderResponsibilities == "";
      });
      if (index > -1) {
        this.$message({
          type: "warning",
          message:
            this.userInfo.eduBuresuType == -1
              ? "请先给处理人员" +
                addGroupData.teamLeaderList[index].userName +
                "增加职责!"
              : "请先给后勤人员" +
                addGroupData.teamLeaderList[index].userName +
                "增加职责!"
        });
        return false;
      }
      if (addGroupData.teamReporters.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选择组员"
        });
        return false;
      }
      addGroupData.schoolId = parseInt(this.$store.state.schoolId);
      let res;
      if (this.type == "add") {
        let req = {
          type: 1,
          schoolId: addGroupData.schoolId,
          securityTeamName: addGroupData.securityTeamName,
          whetherHiddenGroup: addGroupData.whetherHiddenGroup,
          teamMemberList: addGroupData.teamMemberList,
          teamLeaderList: addGroupData.teamLeaderList
        };
        res = await this.$Http.addSecurityTeam(req);
      } else {
        let req = {
          securityTeamId: parseInt(this.id),
          securityTeamName: addGroupData.securityTeamName,
          teamMemberList: addGroupData.teamMemberList,
          teamLeaderList: addGroupData.teamLeaderList
        };
        res = await this.$Http.updateSecurityTeam(req);
      }
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.refeashData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    refeashData() {
      //清除组员数据
      this.$refs.teamMemberTree.setCheckedKeys([]);
      (this.form = {
        schoolId: parseInt(this.$store.state.schoolId),
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [], //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
        teamReporters: [] //组员  userId组员id
      }),
        (this.teamMemberValue = []), //当前选择的组长
        (this.teamLeaderValue = []), //当前选择的后勤人员
        this.$emit("goBack");
    }
  },
  watch: {
    id: function(val) {
      if (val) {
        //   编辑
        for (let index = 0; index < 3; index++) {
          this.getTeamList(index + 1, val);
        }
        this.form = Object.assign({}, this.defaultData);
        this.oldTeamMemberList = this.form.teamMemberList || [];
        this.oldTeamLeaderList = this.form.teamLeaderList || [];
      } else {
        //   新增
        for (let index = 0; index < 3; index++) {
          this.getTeamList(index + 1, "");
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.el-tree {
  width: 100%;
  display: inline-block;
  overflow-y: auto;
  overflow-x: scroll;
  overflow: auto;
  max-height: 200px;
}
.save-box {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
